// extracted by mini-css-extract-plugin
export default {"container":"image-caption_container__PPEqm"};